import { useMemo } from 'react'

import { Project } from '@/api/models/auth/lib/auth.types'
import {
  CreateBookingFormData,
  TariffType
} from '@/api/models/parking/lib/parking.types'
import { getPersonalAccountsByRoomId } from '@/components/entities/requests/ui/model/utils'

type Props = {
  roomId?: string
  selectedPersonalAccountId?: string
  defaultPersonalAccountId?: string
  selectedProject?: Project
  from: string
  to: string
  type: TariffType
  autoModel?: string
  autoNumber?: string
  isStandard?: boolean
}

export const useBookingFormData = ({
  roomId,
  selectedPersonalAccountId,
  defaultPersonalAccountId,
  selectedProject,
  from,
  to,
  type,
  autoModel,
  autoNumber,
  isStandard
}: Props) =>
  useMemo<CreateBookingFormData>(() => {
    const premiseId = roomId ?? ''
    const personalAccountsForRoom = getPersonalAccountsByRoomId(
      premiseId || undefined,
      selectedProject
    )

    const personalAccountId =
      personalAccountsForRoom && personalAccountsForRoom.length > 1
        ? selectedPersonalAccountId ?? defaultPersonalAccountId
        : personalAccountsForRoom?.[0]?.id ?? defaultPersonalAccountId

    return {
      premiseId,
      from,
      to,
      autoModel: autoModel?.trim() ?? '',
      autoNumber: autoNumber?.trim() ?? '',
      type,
      isStandard: isStandard ?? true,
      personalAccountId
    }
  }, [
    roomId,
    selectedPersonalAccountId,
    defaultPersonalAccountId,
    selectedProject,
    from,
    to,
    type,
    autoModel,
    autoNumber,
    isStandard
  ])
